import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconMinimizeAvatar: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M5.59422 14.4064H3.54297C3.36589 14.4064 3.21748 14.3465 3.09776 14.2266C2.9779 14.1068 2.91797 13.9582 2.91797 13.781C2.91797 13.6039 2.9779 13.4555 3.09776 13.3358C3.21748 13.2162 3.36589 13.1564 3.54297 13.1564H6.09109C6.30443 13.1564 6.48332 13.2286 6.62776 13.3729C6.77207 13.5173 6.84422 13.6962 6.84422 13.9096V16.4577C6.84422 16.6348 6.78429 16.7832 6.66443 16.9029C6.54457 17.0228 6.39609 17.0827 6.21901 17.0827C6.04179 17.0827 5.89339 17.0228 5.7738 16.9029C5.65408 16.7832 5.59422 16.6348 5.59422 16.4577V14.4064ZM14.4163 14.4064V16.4577C14.4163 16.6348 14.3564 16.7832 14.2365 16.9029C14.1166 17.0228 13.9682 17.0827 13.7911 17.0827C13.6139 17.0827 13.4655 17.0228 13.3459 16.9029C13.2262 16.7832 13.1663 16.6348 13.1663 16.4577V13.9096C13.1663 13.6962 13.2385 13.5173 13.383 13.3729C13.5273 13.2286 13.7062 13.1564 13.9196 13.1564H16.4676C16.6446 13.1564 16.7931 13.2164 16.913 13.3362C17.0327 13.4561 17.0926 13.6046 17.0926 13.7816C17.0926 13.9589 17.0327 14.1073 16.913 14.2269C16.7931 14.3466 16.6446 14.4064 16.4676 14.4064H14.4163ZM5.59422 5.59227V3.54102C5.59422 3.36393 5.65415 3.21553 5.77401 3.09581C5.89387 2.97595 6.04241 2.91602 6.21964 2.91602C6.39672 2.91602 6.54512 2.97595 6.66484 3.09581C6.78443 3.21553 6.84422 3.36393 6.84422 3.54102V6.08914C6.84422 6.30247 6.77207 6.48136 6.62776 6.62581C6.48332 6.77011 6.30443 6.84227 6.09109 6.84227H3.54297C3.36589 6.84227 3.21748 6.78234 3.09776 6.66247C2.9779 6.54261 2.91797 6.39414 2.91797 6.21706C2.91797 6.03984 2.9779 5.89143 3.09776 5.77185C3.21748 5.65213 3.36589 5.59227 3.54297 5.59227H5.59422ZM14.4163 5.59227H16.4676C16.6446 5.59227 16.7931 5.6522 16.913 5.77206C17.0327 5.89192 17.0926 6.04046 17.0926 6.21768C17.0926 6.39477 17.0327 6.54317 16.913 6.66289C16.7931 6.78247 16.6446 6.84227 16.4676 6.84227H13.9196C13.7062 6.84227 13.5273 6.77011 13.383 6.62581C13.2385 6.48136 13.1663 6.30247 13.1663 6.08914V3.54102C13.1663 3.36393 13.2262 3.21553 13.3461 3.09581C13.466 2.97595 13.6145 2.91602 13.7917 2.91602C13.9688 2.91602 14.1172 2.97595 14.2369 3.09581C14.3565 3.21553 14.4163 3.36393 14.4163 3.54102V5.59227Z"
        fill={color}
      />
    </svg>
  );
};

export default IconMinimizeAvatar;
